import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

import {
    resetCreateStatus,
    fetchAllBanks,
    deleteBank
} from "../../store/bank-setting-slice";
import {useSearchParams} from "react-router-dom";
import Button from "../../components/common/button/Button";
import SubHeader from "../../components/header/SubHeader";
import Table from "../../components/common/table/Table";
import {getTableColumns, getTableData} from "../../models/bankModel";
import ActionDropdown from "../../components/actions/ActionDropdown";

const BankView = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    const {
        items,
        fetchStatus,
        createStatus,
        error
    } = useSelector(state => state.bankSetting); // Updated selector

    const userRole = useSelector((state) => state.auth.selectedRole);
    //set initial page and limit
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialLimit = Number(searchParams.get("limit")) || 25;

    useEffect(() => {
        dispatch(fetchAllBanks({
            ...userRole,
            page: initialPage,
            limit: initialLimit
        }));
    }, [dispatch, userRole, initialPage, initialLimit]);

    useEffect(() => {
        if (createStatus === "success") {
            dispatch(resetCreateStatus());
        }
    }, [dispatch, createStatus]);

    const deleteHandler = (id) => {
        dispatch(deleteBank({id, ...userRole})); // Updated action
    };

    const tableColumns = getTableColumns({ActionDropdown, deleteHandler});
    const tableData = getTableData({items});

    return (
        <>
            <SubHeader title="All Banks">
                <Button to="add" className="btn-sm bg-primary bg-opacity-50">Add New</Button>
            </SubHeader>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" && (
                <Table
                    className="mobile-responsive"
                    columns={tableColumns}
                    data={tableData}
                />
            )}
        </>
    );
};

export default BankView;
